import { render, staticRenderFns } from "./GuideMigrate.vue?vue&type=template&id=5695b750&"
import script from "./GuideMigrate.vue?vue&type=script&lang=js&"
export * from "./GuideMigrate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports